'use es6';

import { byName } from 'ContentUtils/constants/TemplateTypes';
/**
 * @param {Object} layout
 * @return {Boolean}
 */

export function isGlobalGroup(layout) {
  return layout && layout.templateType === byName.global_group.id;
}